import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconChevronFilled(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m5 8 2-2-2-2z" />
    </SVGIcon>
  );
}
